export default [
  {
    id: '200950',
    firstName: 'Jeff',
    lastName: 'Winger',
    name: 'Jeff Winger',
    email: 'j.winger@greendale.edu.test',
    preferredDisplayName: 'Jeff',
    lastUserAccess: 1670348943001,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'SYNCED',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'j.winger',
    managed: true,
    yearGroup: 'N12',
  },
  {
    id: '200951',
    firstName: 'Britta',
    lastName: 'Perry',
    name: 'Britta Perry',
    email: 'b.perry@greendale.edu.test',
    preferredDisplayName: 'Britta',
    lastUserAccess: 1670348943002,
    emailStatus: 'VERIFIED',
    accountStatus: 'SYNCED',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'b.perry',
    managed: true,
  },
  {
    id: '200952',
    firstName: 'Abed',
    lastName: 'Nadir',
    name: 'Abed Nadir',
    email: 'a.nadir@greendale.edu.test',
    preferredDisplayName: 'Abed',
    lastUserAccess: 1670348943003,
    emailStatus: 'VERIFIED',
    accountStatus: 'PENDING',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'a.nadir',
    yearGroup: '6',
  },
  {
    id: '200953',
    firstName: 'Shirley',
    lastName: 'Bennett',
    name: 'Shirley Bennett',
    email: 's.bennett@greendale.edu.test',
    preferredDisplayName: 'Shirley',
    lastUserAccess: 1670348943004,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 's.bennett',
    yearGroup: 'Year 1',
  },
  {
    id: '200954',
    firstName: 'Annie',
    lastName: 'Edison',
    name: 'Annie Edison',
    email: 'a.edison@greendale.edu.test',
    preferredDisplayName: 'Annie',
    lastUserAccess: 1670348943005,
    emailStatus: 'VERIFIED',
    accountStatus: 'PENDING',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'a.edison',
  },
  {
    id: '200955',
    firstName: 'Troy',
    lastName: 'Barnes',
    name: 'Troy Barnes',
    email: 't.barnes@greendale.edu.test',
    preferredDisplayName: 'Troy',
    lastUserAccess: 1670348943006,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 't.barnes',
  },
  {
    id: '200956',
    firstName: 'Pierce',
    lastName: 'Hawthorne',
    name: 'Pierce Hawthorne',
    email: 'p.hawthorne@greendale.edu.test',
    preferredDisplayName: 'Pierce',
    lastUserAccess: 1670348943007,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'p.hawthorne',
    yearGroup: '12',
  },
  {
    id: '200957',
    firstName: 'Ben',
    lastName: 'Chang',
    name: 'Ben Chang',
    email: 'b.chang@greendale.edu.test',
    preferredDisplayName: 'Ben',
    lastUserAccess: 1670348943008,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'b.chang',
  },
  {
    id: '200958',
    firstName: 'Garrett',
    lastName: 'Lambert',
    name: 'Garrett Lambert',
    // email: 'g.lambert@greendale.edu.test',
    preferredDisplayName: 'Garrett',
    lastUserAccess: 1670348943009,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'g.lambert',
  },
  {
    id: '200959',
    firstName: 'Leonard',
    lastName: 'Rodriguez',
    name: 'Leonard Rodriguez',
    // email: 'l.rodriguez@greendale.edu.test',
    preferredDisplayName: 'Leonard',
    lastUserAccess: 1670348943010,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'l.rodriguez',
    signedUpWithSSO: true,
  },
  {
    id: '200960',
    firstName: 'Rich',
    lastName: 'Stephenson',
    name: 'Rich Stephenson',
    email: 'r.stephenson@greendale.edu.test',
    preferredDisplayName: 'Rich',
    lastUserAccess: 1670348943011,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'r.stephenson',
  },
  {
    id: '200961',
    firstName: 'Annie',
    lastName: 'Kim',
    name: 'Annie Kim',
    email: 'a.kim@greendale.edu.test',
    preferredDisplayName: 'Annie',
    lastUserAccess: 1670348943012,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'a.kim',
  },
  {
    id: '200962',
    firstName: 'Todd',
    lastName: 'Jacobson',
    name: 'Todd Jacobson',
    email: 't.jacobson@greendale.edu.test',
    preferredDisplayName: 'Todd',
    lastUserAccess: 1670348943013,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 't.jacobson',
  },
  {
    id: '200963',
    firstName: 'Alex',
    lastName: 'Osbourne',
    name: 'Alex Osbourne',
    // email: 'a.osbourne@greendale.edu.test',
    preferredDisplayName: 'Star-Burns',
    lastUserAccess: 1670348943014,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200964',
    firstName: 'Pavel',
    lastName: 'Nadir',
    name: 'Pavel Nadir',
    // email: 'p.nadir@greendale.edu.test',
    preferredDisplayName: 'Pavel',
    lastUserAccess: 1670348943015,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'DEACTIVATED',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'p.nadir',
  },
  {
    id: '200965',
    firstName: 'Jeremy',
    lastName: 'Gupta',
    name: 'Jeremy Gupta',
    email: 'j.gupta@citycollege.edu.test',
    preferredDisplayName: 'Jeremy',
    lastUserAccess: 1670348943016,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'City College',
    linkedPurchaserId: '10003',
    username: 'j.gupta',
  },
  {
    id: '200966',
    firstName: 'Kim',
    lastName: 'Franco',
    name: 'Kim Franco',
    email: 'k.franco@citycollege.edu.test',
    preferredDisplayName: 'Kim',
    lastUserAccess: 1670348943017,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'City College',
    linkedPurchaserId: '10003',
    username: 'k.franco',
  },
  {
    id: '200967',
    firstName: 'Carlos',
    lastName: 'Ramirez',
    name: 'Carlos Ramirez',
    email: 'c.ramirez@citycollege.edu.test',
    preferredDisplayName: 'Carlos',
    lastUserAccess: 1670348943018,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'City College',
    linkedPurchaserId: '10003',
    username: 'c.ramirez',
  },
  {
    id: '200968',
    firstName: 'Tina',
    lastName: 'Walker',
    name: 'Tina Walker',
    email: 't.walker@citycollege.edu.test',
    preferredDisplayName: 'Tina',
    lastUserAccess: 1670348943019,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'City College',
    linkedPurchaserId: '10003',
    username: 't.walker',
  },
  {
    id: '200969',
    firstName: 'Mark',
    lastName: 'Nelson',
    name: 'Mark Nelson',
    email: 'm.nelson@citycollege.edu.test',
    preferredDisplayName: 'Mark',
    lastUserAccess: 1670348943020,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'City College',
    linkedPurchaserId: '10003',
    username: 'm.nelson',
  },
  {
    id: '200970',
    firstName: 'Sarah',
    lastName: 'Taylor',
    name: 'Sarah Taylor',
    email: 's.taylor@citycollege.edu.test',
    preferredDisplayName: 'Sarah',
    lastUserAccess: 1670348943021,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'City College',
    linkedPurchaserId: '10003',
    username: 's.taylor',
  },
  {
    id: '200971',
    firstName: 'Peter',
    lastName: 'Profilepicture',
    name: 'Peter Profilepicture',
    email: 'p.profilepicture@citycollege.edu.test',
    preferredDisplayName: 'Peter',
    lastUserAccess: 1670348943021,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    username: 'p.profilepicture',
    yearGroup: '8',
    avatarSmallUrl: '/assets/favicon/favicon-32x32.png',
    avatarMediumUrl: '/assets/favicon/android-chrome-192x192.png',
  },
  {
    id: '200972',
    firstName: 'Rodney',
    lastName: 'Regularstudent',
    name: 'Rodney Regularstudent',
    email: 'r.regularstudent@athabascahigh.edu.test',
    preferredDisplayName: 'Rodney',
    lastUserAccess: 1670348943021,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    schoolVerified: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
    username: 'r.regularstudent',
  },
  {
    id: '200973',
    firstName: 'Darryl',
    lastName: 'Deactivatedstudent',
    name: 'Darryl Deactivatedstudent',
    email: 'd.deactivatedstudent@athabascahigh.edu.test',
    preferredDisplayName: 'Darryl',
    lastUserAccess: 1670348943021,
    emailStatus: 'VERIFIED',
    accountStatus: 'DEACTIVATED',
    schoolVerified: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
    username: 'd.deactivatedstudent',
  },
  {
    id: '200974',
    firstName: 'Samuel',
    lastName: 'Syncedstudent',
    name: 'Samuel Syncedstudent',
    email: 's.syncedstudent@athabascahigh.edu.test',
    preferredDisplayName: 'Samuel',
    lastUserAccess: 1670348943021,
    emailStatus: 'VERIFIED',
    accountStatus: 'SYNCED',
    schoolVerified: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
    username: 's.syncedstudent',
  },
  {
    id: '200975',
    firstName: 'Percy',
    lastName: 'Pendingstudent',
    name: 'Percy Pendingstudent',
    email: 'p.pendingstudent@athabascahigh.edu.test',
    preferredDisplayName: 'Percy',
    lastUserAccess: 1670348943021,
    emailStatus: 'VERIFIED',
    accountStatus: 'PENDING',
    schoolVerified: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
    username: 'p.pendingstudent',
  },
];
